import React from 'react';
import About from '../components/UI/About';

const AboutPage = () => {
  return (
    <div className="about-page">
      <About />
    </div>
  );
};

export default AboutPage; 